<textarea readonly #textElement>{{ value }}</textarea>
<span (click)="copyToClipboard(textElement)" [ngClass]="btnClass">
	<ng-content></ng-content>
</span>
